import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  currentUser: any;
  constructor(private authService: AuthService, private router: Router) {}
  errormessage = '';
  ngOnInit(): void {}

  onLogin(credentials: {
    userid: string;
    password: string;
    remember_me: boolean;
  }) {
    this.errormessage = '';
    this.authService.login(credentials.userid, credentials.password).subscribe({
      next: (val: any) => {
        // if (!val) {
        //   this.errormessage = 'Invalid userid/password.';
        // } else {
        //   let user: any = {
        //     accessToken: val.accessToken,
        //     tokenType: val.tokenType,
        //     refreshToken: val.refreshToken,
        //   };
        //   this.router.navigateByUrl('/');
        //   this.authService.setCurrentUser(user, credentials.remember_me);
        // }
        this.currentUser = val
          .filter(
            (a) =>
              a.userid == credentials.userid &&
              a.password == credentials.password
          )
          .map((a) => ({
            accessToken: a.accessToken,
            tokenType: a.tokenType,
            name: a.name,
            role: a.role,
            
          }));
        if (this.currentUser.length !== 0) {
          let user: any = {
            accessToken: this.currentUser[0].accessToken,
            tokenType: this.currentUser[0].tokenType,
            name: this.currentUser[0].name,
            role:this.currentUser[0].role,
          };
          this.router.navigateByUrl('/');
          this.authService.setCurrentUser(user, credentials.remember_me);
        } else {
          this.errormessage = 'Invalid Username or Password.';
        }
      },
      error: (err) => {
        this.errormessage = 'Invalid userid/password..Please try again.';
      },
    });
  }
}
